// extracted by mini-css-extract-plugin
export default {"DashboardPage":"DashboardPage_DashboardPage__5jX-3"};